import { Box, Typography } from '@mui/material';

import { APP_DISPLAY_VERSION } from '~/utils/constants';

export function PublicFooter() {
  return (
    <Box
      component="footer"
      className="noPrint"
      sx={{
        py: 2,
        px: 2,
        textAlign: 'center',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Version {APP_DISPLAY_VERSION}
      </Typography>
    </Box>
  );
}
